import { createTheme, ThemeProvider } from "@mui/material";
import { useCallback, useState } from "react";
import HeaderComponent from "../Common/Header";
import { useSidebarDesk } from "../ContextAPI/SidebarContextDesktop";
// import Support from "../Common/Support";
import CustomSnackbar from "../../Sections/Common/snackBar";

const Dashboard = (props) => {
	const [isSandbox, setIsSandbox] = useState(() => {
		const stored = localStorage.getItem("isSandbox");
		return stored === null ? false : stored === "true";
	});

	const [snackbar, setSnackbar] = useState({
		open: false,
		message: "",
		severity: "success",
	});

	const handleCloseSnackbar = () => {
		setSnackbar({ ...snackbar, open: false });
	};

	const { sidebarDeskOpen } = useSidebarDesk();
	const sidebarDeskClass = sidebarDeskOpen ? "remove-padding" : "";

	const sandBoxEventHandler = useCallback(() => {
		const stored = localStorage.getItem("isSandbox");
		setIsSandbox(stored === null ? false : stored === "true");
	}, []);
	const theme = createTheme({
		typography: {
			fontFamily: "var(--app-font)",
			fontSize: 18, // Base font size in px
		},
		components: {
			MuiCard: {
				styleOverrides: {
					root: {
						borderRadius: "0px !important", // Optional: rounded corners
					},
				},
			},
		},
	});

	return (
		// aside-enabled
		<ThemeProvider theme={theme}>
			<div
				className={
					isSandbox
						? " sandbox dashboard d-flex flex-column flex-root header-fixed header-tablet-and-mobile-fixed toolbar-enabled aside-enabled aside-fixed"
						: "  dashboard d-flex flex-column flex-root header-fixed header-tablet-and-mobile-fixed toolbar-enabled aside-enabled aside-fixed"
				}
			>
				<div
					className={`wrapper d-flex flex-column flex-row-fluid ${sidebarDeskClass}`}
					id="kt_wrapper"
				>
					<div className="header-fixed header-tablet-and-mobile-fixed ">
						<CustomSnackbar
							open={snackbar.open}
							message={snackbar.message}
							severity={snackbar.severity}
							onClose={handleCloseSnackbar}
						/>
						<HeaderComponent sandBoxEvent={sandBoxEventHandler} />
					</div>

					<div className="container-fluid flex-grow-1">
						<div className="flex-column-fluid" id="kt_content">
							{props.sectionName}
						</div>
					</div>
				</div>
			</div>
		</ThemeProvider>
	);
};

export default Dashboard;
